export abstract class ServiceWorkerStaticValues {
   public static readonly DO_NOTHING_ACTION = 'DO_NOTHING_ACTION';

   public static readonly ACCEPT_CALL_NOTIFICATION_ACTION = 'ACCEPT_CALL_ACTION';

   public static readonly DECLINE_CALL_NOTIFICATION_ACTION = 'DECLINE_CALL_ACTION';

   public static readonly AWAITING_CALL_NOTIFICATION_TAG = 'ACCEPT_CALL_TAG';

   public static readonly AWAITING_CHAT_NOTIFICATION_TAG = 'OPEN_CHAT_TAG';

   public static readonly ASSIGNED_MESSAGE_NOTIFICATION_TAG = 'ASSIGNED_MESSAGE_NOTIFICATION_TAG';

   public static readonly OPEN_MESSAGE_NOTIFICATION_ACTION = 'OPEN_MESSAGE_NOTIFICATION_ACTION';

   public static readonly OPEN_CHAT_NOTIFICATION_ACTION = 'OPEN_CHAT_NOTIFICATION_ACTION';

   public static readonly UNREACHABLE_NOTIFICATION_TAG = 'UNREACHABLE_NOTIFICATION_TAG';

   public static readonly RESOLVE_UNREACHABLE_NOTIFICATION_ACTION = 'RESOLVE_UNREACHABLE_NOTIFICATION_ACTION';

   public static readonly NATIVE_NOTIFICATION_CLOSED = 'NATIVE_NOTIFICATION_CLOSED';

   public static readonly NATIVE_NOTIFICATION_CLICKED = 'NATIVE_NOTIFICATION_CLICKED';

   public static readonly REQUIRE_AGENTS_NOTIFICATION_TAG = 'REQUIRE_AGENTS_NOTIFICATION_TAG';

   public static readonly ACCEPT_NEW_OUTBOUND_CALL_REQUEST_ACTION = 'ACCEPT_NEW_OUTBOUND_CALL_REQUEST_ACTION';

   public static readonly NEW_OUTBOUND_CALL_REQUEST_TAG = 'NEW_OUTBOUND_CALL_REQUEST_TAG';

   public static readonly WAITING_ITEM_NOTIFICATION_TAG = 'WAITING_ITEM_NOTIFICATION_TAG';

   public static readonly CANCEL_NEW_OUTBOUND_CALL_REQUEST_ACTION = 'CANCEL_NEW_OUTBOUND_CALL_REQUEST_ACTION';
}
